import { apiJson, type ApiFetchInit } from "../../api/client";
import type { CustomerPortalResponse } from "../types";

export function createCustomerPortal(
  input: { pathname?: string; isUpdatingPlan?: boolean } = {},
  init: ApiFetchInit = {},
): Promise<CustomerPortalResponse> {
  return apiJson<CustomerPortalResponse>("/team/billing/customer-portal", {
    ...init,
    method: "POST",
    headers: { "Content-Type": "application/json", ...init.headers },
    body: JSON.stringify(input),
  });
}
